import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Droplets, Activity } from 'lucide-react';
export function Mechanism() {
  return <section className="py-24 bg-amber/10 px-6 lg:px-8" data-id="element-124">
      <div className="max-w-4xl mx-auto text-center" data-id="element-125">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-126">
          <span className="text-forest font-bold tracking-widest uppercase text-sm mb-4 block" data-id="element-127">
            The Unique Mechanism
          </span>
          <h2 className="text-4xl md:text-5xl font-bold mb-8" data-id="element-128">
            The Nutritional Resynchronization Protocol (Nutri-Sync)
          </h2>
          <p className="text-xl text-charcoal/80 leading-relaxed mb-12" data-id="element-129">
            Unlike stimulants that give you an artificial boost, this method
            identifies the 3 main energy leaks and systematically seals them. We
            don't inject fake energy; we restore your cells' natural ability to
            create their own fuel, eliminating brain fog from the root.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-130">
          {[{
          icon: Activity,
          title: 'Magnesium'
        }, {
          icon: Zap,
          title: 'B-Complex'
        }, {
          icon: Droplets,
          title: 'Electrolytes'
        }].map((leak, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white py-8 px-6 rounded-2xl border border-amber/30 shadow-sm" data-id="element-131">
              <leak.icon className="mx-auto text-amber mb-4" size={32} data-id="element-132" />
              <h3 className="text-xl font-serif font-bold text-forest" data-id="element-133">
                {leak.title}
              </h3>
            </motion.div>)}
        </div>
      </div>
    </section>;
}